export default __webpack_public_path__ + "static/media/hoovertitle1.163099b5.png";